function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}

export const getRandomKey = () => {
  return String(Date.now()).concat(String(getRandomInt(1, 100000)));
}
